
import * as React from "react";
import classNames from "classnames";
import withStyles, { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { Droppable } from '../react-beautiful-dnd';
import { TagCard } from './TagCard'
import { PhaseTag } from "../../models/PhaseTag";
import { Trade } from "../../models/Trade";
import moment, { Moment } from 'moment'
import { Tag } from "../../models/Tag";

import { lightBlue, lightGreen } from "@material-ui/core/colors";

import { ContextMenuTrigger } from "react-contextmenu";
import { uiActions } from "../../actions/ui.actions";
import { ThunkDispatch } from "redux-thunk";
import { compose } from "redux";
import { connect } from "react-redux";
import {  isHistogramOpen, TradeAndCrew,  getTagsByIndex, isDropZoneSelected, isPendingDropZone, isPendingPasteDropZone, getCrewSize, getTradesByCrewsize, makeIsToday, getMaxIndex, isCellHighlighted, getRowGroups, getClosedRowGroups, shouldColorBottomBorder, getGroupColor, isGroupStart, getGroupBounds, isInGroupBounds, Bound, isLookaheadHistogramOpen, getLookaheadColumnTagsByColumn, getLookaheadTrades, TagRecord, getForceRefreshColumns } from "../../selectors/lookahead.selector";
import TrackVisibility from '../react-on-screen';
import Tooltip from '@material-ui/core/Tooltip';
import { getSize, getZoomAmount } from "./Zoom.util";
import Typography from "@material-ui/core/Typography";
import { lookaheadActions } from "../../actions/lookahead.actions";
import {Animated} from "react-animated-css";
import { GroupTag } from "./GroupTag";
import { InnerList } from "./InnerList";
import { RowGroup } from "../../models/Lookahead";
import { columnStyle } from "../../containers/dockPadStyle";

const _ = require('lodash')

interface HistogramProps {
    classes: ClassNameMap;
    zoomStep: number;
    trades: Record<string, Trade>;
    tagsByCrewsize: Record<string, TradeAndCrew>;
    crewSize: number;
}

class _Histogram extends React.Component<HistogramProps, {}> {
    render() {
        const { zoomStep, crewSize, classes } = this.props
        const { titleFontSize } = getSize(getZoomAmount(zoomStep))

        return (
            <div className={classes.HistogramContainer}>
                <Typography className={classNames(classes.LookaheadTitleText)} style={{fontSize: titleFontSize}}>{crewSize}</Typography>
                <div className={classes.Histogram }>
                    {this.renderTradeHistogram(crewSize)}
                </div>
            </div>
        )
    }

    renderTradeHistogram = (sum: number) => {
        const { tagsByCrewsize, trades } = this.props;
        // x / 50 = tradeCrewSize / sum
        const MAX_HEIGHT = 50
        const sortedCrewTagList = _.sortBy(Object.entries(tagsByCrewsize).map(entry => {
            entry[1]['uid'] =entry[0]
            return entry[1]
        }), 'crewSize')

        return sortedCrewTagList.map((crewAndTrade:any) => {
            const crewSize:number = crewAndTrade.crewSize
            let height = MAX_HEIGHT

            if (sum <= 15) {
                height = (crewSize / 15) * MAX_HEIGHT
            } else {
                height = (crewSize/ sum)* MAX_HEIGHT
            }

            const color = trades[crewAndTrade.uid].color
            const tradeName = trades[crewAndTrade.uid].name
            return (
                <Tooltip title={tradeName + ' Crew Size: ' + crewSize}>
                    <div style={{width: '100%', height: height, backgroundColor: color}}>
                    </div>
                </Tooltip>
            )
        })
    }
}

const mapHistogramStateToProps = (state:any, ownProps?: any) => ({
    crewSize: getCrewSize(state, ownProps),
    tagsByCrewsize: getTradesByCrewsize(state, ownProps),
});

const Histogram = compose(
    connect(mapHistogramStateToProps),
)(_Histogram)
 
export enum  ColumnType {
    Lookahead='Lookahead',
    PhasePlan='PhasePlan'
}

interface ColumnProps {
    isOffDay: boolean;
    _isHistogramOpen: boolean
    type: ColumnType;
    isDisabled: boolean;
    classes: ClassNameMap;
    zoomStep: number;
    tags: TagRecord[];
    column: number;
    trades: Record<string, Trade>;
    ref:any;
    isToday: boolean;
    onColumnSelect: (column: string) => void,
    rowGroups: Record<string, RowGroup>;
    closedRowGroups: number[];
    groupBounds: Record<string, Bound>;
    isAdmin: boolean
    userTrades: Set<string>;
    forceRefreshColumns: string[];
    maxIndex: number;
}

class _Column extends React.Component<ColumnProps, {}> {

    maxDuration = () => {
        const phaseTags = this.props.tags as PhaseTag[]
        let maxDuration = 0
        phaseTags.forEach((tag:PhaseTag) => {
            if(tag.duration > maxDuration) {
                maxDuration = tag.duration
            }
        });

        return maxDuration
    }


    renderToday = () => {
        const { isToday } = this.props

        if(!isToday) return

        return (
            <p style={{fontSize: 10, margin: 0}}>
                Today
            </p>
        )
    }

    renderDate = () => {

    }

    onColumnClick = (column: string) => {

        this.props.onColumnSelect(column)
    }

    renderTitle = () => {
        const { classes, type, column, isToday } = this.props
        const { titleFontSize } = getSize(getZoomAmount(this.props.zoomStep))

        if(type === ColumnType.PhasePlan) {
            return (
                <div className={classNames(classes.LookaheadTitleContainer)}>
                    <p>{this.maxDuration()}</p>
                </div>
            )
        }

        if( type === ColumnType.Lookahead) {
            const day = moment(column)

            const todayClass = isToday ? classes.LookaheadTitleContainerToday : ""
            
            return(
                <div onClick={this.onColumnClick.bind(this, column)} className={classNames(classes.LookaheadTitleContainer, todayClass)}>
                    <Typography className={classNames(classes.LookaheadTitleText)} style={{fontSize: titleFontSize}}>{day.format('ddd')}</Typography> 
                    <Typography className={classNames(classes.LookaheadTitleSubText)} style={{fontSize: titleFontSize}}>{day.format('M/D/YY')}</Typography> 
                </div>
            )
        }
    }

    shouldComponentUpdate(nextProps :ColumnProps) {
        if(!_.isEqual(nextProps.tags, this.props.tags)){
            return true
        }

        if(nextProps.maxIndex != this.props.maxIndex) {
            return true
        }

        if(nextProps.isDisabled !== this.props.isDisabled) {
            return true
        }

        if(!_.isEqual(nextProps.trades, this.props.trades)) {
            return true
        }

        if(nextProps.zoomStep !== this.props.zoomStep) {
            return true
        }

        if(nextProps.isOffDay != this.props.isOffDay) {
            return true
        }

        if(nextProps.column != this.props.column) {
            return true
        }


        if(nextProps._isHistogramOpen !== this.props._isHistogramOpen) {
            return true
        }

        if(!_.isEqual(nextProps.closedRowGroups, this.props.closedRowGroups)){
            return true
        }

        if(!_.isEqual(nextProps.forceRefreshColumns, this.props.forceRefreshColumns)) {
            return true
        }

        return false
    }

    render() {
        const { isAdmin, userTrades, groupBounds, classes, isOffDay, column, type, isDisabled, zoomStep, trades, tags, isToday, maxIndex, rowGroups, closedRowGroups } = this.props
        const offDayClass = !!this.props.isOffDay ? this.props.classes.OffDayBackground : ""

        return (
            <React.Fragment>
                <div className={classNames(classes.ColumnTitle)}>
                    {this.props._isHistogramOpen && <Histogram column={column} trades={trades} classes={classes} zoomStep={zoomStep} />}
                    {this.renderTitle()}
                </div>
                <div className={classNames(this.props.classes.PhasePlanColumn, offDayClass)}>
                    <InnerList
                        isOffDay={isOffDay}
                        column={column}
                        type={type}
                        isDisabled={isDisabled}
                        zoomStep={zoomStep}
                        classes={classes}
                        trades={trades} 
                        tags={tags}
                        isToday={isToday}
                        maxIndex={maxIndex}
                        rowGroups={rowGroups}
                        closedRowGroups={closedRowGroups}
                        groupBounds={groupBounds}
                        isAdmin={isAdmin}
                        userTrades={userTrades}
                    />
                </div>   
            </React.Fragment>
        )
    }
}

const makeMapStateToProps = () => {
    const isToday = makeIsToday();
    const mapStateToProps = (state:any, ownProps?: any) => ({
        _isHistogramOpen: isLookaheadHistogramOpen(state),
        isToday: isToday(state, ownProps),
        maxIndex: getMaxIndex(state),
        rowGroups: getRowGroups(state),
        closedRowGroups: getClosedRowGroups(state),
        tags: getLookaheadColumnTagsByColumn(state, ownProps),
        trades: getLookaheadTrades(state),
        forceRefreshColumns: getForceRefreshColumns(state)
    });
    return mapStateToProps;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        onColumnSelect: (column: string) => dispatch(lookaheadActions.onColumnSelect(column)),
    }
};

interface ColumnOwnprops {
    classes: ClassNameMap;
    column: number;
    index: number;
    isDisabled: boolean;
    tags: Tag[];
    trades: Record<string, Trade>;
    type: ColumnType;
    zoomStep: number;
}

const ColumnConnected = compose(
    connect(makeMapStateToProps, mapDispatchToProps),
)(_Column)

const ColumnWrap = (props) => 
    <TrackVisibility 
        className={classNames(props.classes.PhasePlanLocationGridColumn)}
        style={{width: getZoomAmount(props.zoomStep) }}
        throttleInterval={100}
        partialVisibility={true}
        offset={200}
    >
        {({ isVisible }) => isVisible && props.show && <ColumnConnected {...props}/>}
    </TrackVisibility>;

export const Column = compose(
    withStyles(columnStyle, { withTheme: true }),
)(ColumnWrap)


// WEBPACK FOOTER //
// ./src/components/PhasePlan/Column.tsx